import { MktuClass, MktuClassWord } from '@/services/Api/generated'

export enum MKTU_CLASS_CATEGORY {
  PRODUCT = 'PRODUCT',
  SERVICE = 'SERVICE',
}

export const MKTU_CLASS_CATEGORY_TITLE = {
  [MKTU_CLASS_CATEGORY.PRODUCT]: 'товары',
  [MKTU_CLASS_CATEGORY.SERVICE]: 'услуги',
}
export const SEARCH_STRING_MIN_LENGTH = 3

export function getMktuClassTypeByClassNumber(
  classNumber: MktuClass['classNumber']
): MKTU_CLASS_CATEGORY {
  return classNumber <= 34
    ? MKTU_CLASS_CATEGORY.PRODUCT
    : MKTU_CLASS_CATEGORY.SERVICE
}

export enum MktuClassCategory {
  Product = 'Product',
  Service = 'Service',
}

export type MktuClassWithWords = MktuClass & { words: MktuClassWord[] }

export const MktuClassCategoryTitle = {
  Product: 'Товары',
  Service: 'Услуги',
}
